/**
 * The centred page column of the portal's store-like pages (Marktplatz, Alarme): a 1200 px column
 * in the middle of the content area, pulled up into the content panel's top padding. One constant so
 * the pages stay identical.
 */
export const CENTERED_PAGE_CLASS = 'mx-auto flex w-full min-w-0 max-w-[1200px] flex-col gap-4 sm:-mt-2 lg:-mt-6';
